import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Attendance from "./pages/Attendance";
import RegisterEmployee from "./pages/RegisterEmployee";
import './index.css'

export default function App() {
  return (
    <BrowserRouter>
      <Navbar />
      {/* <div className="h-[calc(100dvh-60px)] overflow-hidden"></div> */}
      <Routes>
        <Route path="/" element={<Attendance />} />
        <Route path="/register" element={<RegisterEmployee />} />
      </Routes>
    </BrowserRouter>
  );
}
